import Vue from 'vue'
import Vuex from 'vuex'
import websocketPlugin from '@/store/plugins/websocket-plugin'
import {CC_WEBSOCKET} from '@/store/static/connection-types'

// Framework Modules
import connections from '@windsor-telecom/customer-portal-framework/src/store/modules/connections'
import errors from '@windsor-telecom/customer-portal-framework/src/store/modules/errors'

// Store Modules
import auth from './modules/auth'
import wallboard from './modules/wallboard'
import websocket from './modules/websocket'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth,
        connections: connections([
            CC_WEBSOCKET
        ]),
        errors: errors(),
        wallboard,
        websocket
    },
    plugins: [
        websocketPlugin()
    ]
})
